




















import Vue from 'vue'

type Data = {
  title: string;
};

export default Vue.extend({
  name: 'Complete',
  data (): Data {
    return {
      title: process.env.VUE_APP_TITLE
    }
  },
  methods: {
    toLogin (): void {
      this.$store.dispatch('logout')
    }
  }
})
